import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdPushReportsResponsibleSuspense } from "api/generated/users/users";

export function usePushReportsResponsibleForUserQuery(userId: number) {
    return useGetUsersUserIdPushReportsResponsibleSuspense(userId, {
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
